export default __webpack_public_path__ + "static/cancel-78b0f518a715b5ae40dd7828e8f7e611.png";